import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FilterTypes } from '../../common/components/filter/filterbar/types';
import { useUserRolePreferencesServiceContext } from '../../context/contexts';
import {
  UserRolePreferencesSettings,
  UserRolePreferencesSettingsSettings,
} from './types';

export const useMutateUserRolePreferences = <T extends FilterTypes>() => {
  const userRolePreferencesService = useUserRolePreferencesServiceContext<T>();
  const key = ['userRolePreferences', ...userRolePreferencesService.getDeps()];
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newSettings: UserRolePreferencesSettingsSettings<T>) => {
      return userRolePreferencesService.save(newSettings);
    },
    onSuccess: (data: UserRolePreferencesSettings<T> | null) => {
      // TODO: should we save if the result is null?
      queryClient.setQueryData(key, data);
      return;
    },
  });
};
